module.exports = __webpack_public_path__ + "img/file_yellow.700010c1.svg";